export const OPEN_TOAST  =  "OPEN_TOAST";
export const CLOSE_TOAST  =  "CLOSE_TOAST";
export const OPEN_TOOLTIP  =  "OPEN_TOOLTIP";

export  function dispatchNotification(param){
    return {
      type: param.type,
      payload: param.payload,
    };
}